import {
  FormField,
  Select,
} from '@cloudscape-design/components';
import { Materials } from '@parallel-fluidics/shared/constants';
import PropTypes from 'prop-types';
import React from 'react';

function MaterialSelector({
  setMaterial,
  value = null,
  error = null,
}) {
  const materials = [
    ...(Object.values(Materials).map((material) => ({
      label: material,
      value: material,
    }))),
    { label: 'Other...', value: 'other' },
  ];

  return (
    <FormField
      label="Material"
      stretch
      errorText={error}
    >
      <Select
        selectedOption={value}
        onChange={({ detail }) => setMaterial(detail.selectedOption)}
        options={materials}
        placeholder="Choose a material"
      />
    </FormField>
  );
}

MaterialSelector.propTypes = {
  setMaterial: PropTypes.func.isRequired,
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  error: PropTypes.string,
};

export default MaterialSelector;
